"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _linkButton = _interopRequireDefault(require("../../core/link-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
class MyButton extends _react.Component {
  render() {
    const CHECKOUT_URL = `/checkout`;
    const FAILED_PAYMENTS_URL = `/submit-new-payment`;
    if (this.props.failedChargesforUser.length) {
      return /*#__PURE__*/_react.default.createElement(_linkButton.default, {
        to: FAILED_PAYMENTS_URL,
        type: "danger",
        block: true
      }, "You have", this.props.failedChargesforUser.length, this.props.failedChargesforUser.length > 1 ? ' payments that have ' : ' payment that has ', "failed. Please click here to supply new payment details.\"");
    }
    if (this.props.userEntriesAwaitingPayment) {
      return /*#__PURE__*/_react.default.createElement(_linkButton.default, {
        to: CHECKOUT_URL,
        type: "primary",
        block: true
      }, "Go to checkout (", this.props.userEntriesAwaitingPayment, this.props.userEntriesAwaitingPayment === 1 ? ' entry ' : ' entries ', "awaiting payment)");
    }
    return null;
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref = {
  userEntriesAwaitingPayment: true,
  failedChargesforUser: {
    id: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(MyButton, props => _ref);